const authRoutes = {
  accountConfirmation: '/account-confirmation',
  accountConfirmed: '/account-confirmed/:token?',
  accountNotActivated: '/account-not-activated',
  accountNotActive: '/account-not-active',
  accountUnauthorized: '/unauthorized',

  login: '/login',
  passwordRecovery: '/password-recovery',
  passwordReset: '/password-reset/:token?',
  passwordResetSuccess: '/password-reset-success',
  register: '/register/:token?',
} as const;

const brandingRoutes = {
  branding: '/branding/:id',
  brandings: '/brandings',
  brandingNew: '/branding/new',
} as const;

const campaignRoutes = {
  campaign: '/campaign/:id/:slotId?',
  campaignEdit: '/campaign/:id/edit',
  campaignNew: '/campaign/new',
  campaigns: '/campaigns',
} as const;

const deviceRoutes = {
  device: '/device/:id',
  deviceNew: '/device/new',
  devices: '/devices',
} as const;

const interactionRoutes = {
  interaction: '/interaction/:id',
  interactionNew: '/interaction/new/:dictionaryId?',
  interactions: '/interactions',
} as const;

const interactionDictionaryRoutes = {
  interactionDictionary: '/interaction-dictionary/:id',
  interactionsDictionary: '/interactions-dictionary',
  interactionsDictionaryNew: '/interaction-dictionary/new',
} as const;

const themeRoutes = {
  theme: '/theme/:id',
  themeNew: '/theme/new/:dictionaryId',
  themes: '/themes',
} as const;

const appRoutes = {
  dashboard: '/',
  users: '/users',
} as const;

const devRoutes = {
  developmentPreview: '/development-preview',
} as const;

const routes = {
  ...authRoutes,
  ...brandingRoutes,
  ...campaignRoutes,
  ...deviceRoutes,
  ...interactionRoutes,
  ...interactionDictionaryRoutes,
  ...themeRoutes,
  ...appRoutes,
  ...devRoutes,
} as const;

const links = {
  accountConfirmation: '/account-confirmation',
  accountConfirmed: '/account-confirmed',
  accountNotActivated: '/account-not-activated',
  accountNotActive: '/account-not-active',
  accountUnauthorized: '/unauthorized',
  branding: '/branding',
  brandingNew: '/branding/new',
  brandings: '/brandings',
  campaign: '/campaign',
  campaignEdit: '/campaign',
  campaignNew: '/campaign/new',
  campaigns: '/campaigns',
  companyActivation: '/company-activation',
  companyNotFound: '/company-not-found',
  dashboard: '/',
  developmentPreview: '/development-preview',
  device: '/device',
  deviceNew: '/device/new',
  devices: '/devices',
  interaction: '/interaction',
  interactionDictionary: '/interaction-dictionary',
  interactionDictionaryNew: '/interaction-dictionary/new',
  interactionNew: '/interaction/new',
  interactions: '/interactions',
  interactionsDictionary: '/interactions-dictionary',
  login: '/login',
  passwordRecovery: '/password-recovery',
  passwordReset: '/password-reset',
  passwordResetSuccess: '/password-reset-success',
  register: '/register',
  theme: '/theme',
  themeNew: '/theme/new',
  themes: '/themes',
  users: '/users',
} as const;

export { authRoutes, links, routes };
